import React from "react";
import  ReactHtmlParser  from "react-html-parser";
import { sanitizeHTML } from "./SanitizeHTML";
export const HTMLParserHelper = (content) => {
  try {
    return ReactHtmlParser(content);
  } catch {
    return <div dangerouslySetInnerHTML={sanitizeHTML(content)} />;
  }
};
